/**
 * 多维分析和号码包管理页面的 拖拽相关
 */
export default {
  dbl_sortable_drag_drag_and_drop: "Drag and Drop to add",
  dbl_sortable_drag_batch_add_or_drag_drop: "Batch add or drag & drop",
  dbl_sortable_drag_lease: "least",
  dbl_sortable_drag_release_mouse: "Release Mouse",
  dbl_sortable_drag_search_result: "Search result（{length}）",
  dbl_sortable_drag_loading: "Data loading...",
	
  dbl_sortable_drag_input_number: "Number",
  dbl_sortable_drag_input_number_placeholder: "Input Number",
  dbl_sortable_drag_overall: "Overall",
  dbl_sortable_drag_255_tip: "Display data results based on de-duplicated users for all {text}",
  dbl_sortable_drag_all_unique: " All (Unique Users)",
  dbl_sortable_drag_all_sum: "All (SUM All Users)",

  dbl_sortable_drag_dimension_map_set: "Mapping Relationship Setting",
  dbl_sortable_drag_dimension_map_require: "Can not be empty",
  dbl_sortable_drag_dimension_map_max: "Maximum 20 characters",
  dbl_sortable_drag_dimension_map_icon: "Select icon",
  dbl_sortable_drag_dimension_map_name: "Enter display dimension values",
  dbl_sortable_drag_dimension_map_value: "Match field value selection",
  dbl_sortable_drag_dimension_map_name_duplicate: "Duplicated naming",

  dbl_sortable_drag_dimension_icon_column_category: "Category",
  dbl_sortable_drag_dimension_icon_category_platform: "Platform",
  dbl_sortable_drag_dimension_icon_category_sentiment: "Sentiment",
  dbl_sortable_drag_dimension_icon_category_country: "Country",
  dbl_sortable_drag_dimension_icon_category_others: "Others",
  dbl_sortable_drag_dimension_icon_name_xbox: "Xbox",
  dbl_sortable_drag_dimension_icon_name_epics: "Epic Games",
  dbl_sortable_drag_dimension_icon_name_steam: "Steam",
  dbl_sortable_drag_dimension_icon_name_playstation: "PlayStation",
  dbl_sortable_drag_dimension_icon_name_nintendo: "Nintendo",
  dbl_sortable_drag_dimension_icon_name_sentiment_positive: "Positive",
  dbl_sortable_drag_dimension_icon_name_sentiment_negative: "Negative",
  dbl_sortable_drag_dimension_icon_name_sentiment_neutral: "Neutral",
  dbl_sortable_drag_dimension_icon_name_default: "Default",
  dbl_sortable_drag_dimension_icon_name_iphone: "iPhone",
  dbl_sortable_drag_dimension_icon_name_monitor: "Monitor",
  dbl_sortable_drag_dimension_icon_name_console_line: "Console",
  dbl_sortable_drag_dimension_icon_search_placeholder: "Search name (EN/ZH) or country code",
  dbl_sortable_drag_dimension_icon_search_no_results: "No matches",

  // dbl_sortable_drag_include: "include",
  // dbl_sortable_drag_exclude: "exclude",
  // dbl_sortable_drag_greater: "greater",
  // dbl_sortable_drag_less: "less",
  // dbl_sortable_drag_greaterOrEqual: "大于等于",
  // dbl_sortable_drag_lessOrEqual: "小于等于",
  // dbl_sortable_drag_equal: "equal",
  // dbl_sortable_drag_notEqual: "not equal",
  // dbl_sortable_drag_between: "between",
  // dbl_sortable_drag_notNul: "有值",
  // dbl_sortable_drag_sum: "sum",
  // dbl_sortable_drag_avg: "avg",
  // dbl_sortable_drag_max: "max",
  // dbl_sortable_drag_min: "min",
  // dbl_sortable_drag_avgpp: "人均值",
  // dbl_sortable_drag_distinct: "distinct",
  // dbl_sortable_drag_count: "count",
  // dbl_sortable_drag_variance: "方差",
  // dbl_sortable_drag_std: "标准差",
};